export const stringToHex = (str: string) => {
  let hash = 0;
  
  // 1. Generate a hash from the string
  for (let i = 0; i < str.length; i++) {
    // Left-shift bitwise operator to create a large integer
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // 2. Convert the integer to a 6-character hex code
  let color = '#';
  for (let i = 0; i < 3; i++) {
    // Extract 8 bits and convert to hex
    const value = (hash >> (i * 8)) & 0xFF;
    color += value.toString(16).padStart(2, '0');
  }

  return color;
};
